import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SchematronValidationError } from '../../../types/schematron-validation-error';
import { filter, take } from 'rxjs/operators';
import { FormType } from '../../../types/form-type';
import { DateUtilsService } from '../../../utils/date-utils-service';
import version from '../../../../environments/version.json';
import { EditorConfigurationProvider } from '../../../services/editor-configuration.provider';

@Component({
  selector: 'app-schematron-dialog',
  templateUrl: './schematron-dialog.component.html',
  styleUrls: ['./schematron-dialog.component.scss'],
})
export class SchematronDialogComponent {
  displayedColumns = ['ruleId', 'description'];

  buildNumber: string;
  buildVersion: string;
  dateAsText: string;

  constructor(
    private dateUtilsService: DateUtilsService,
    private editorConfigurationProvider: EditorConfigurationProvider,
    @Optional() dialogRef?: MatDialogRef<SchematronDialogComponent>,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data?: {
      schematronErrors: SchematronValidationError[];
      formType: FormType;
    }
  ) {
    this.configureDialog(dialogRef);
  }

  getFirstLineErrorMessage() {
    return `${this.data.formType} konnte nicht ${
      this.editorConfigurationProvider.isCreationMode() ? 'angelegt' : 'aktualisiert'
    } werden.`;
  }

  private configureDialog(dialogRef: MatDialogRef<SchematronDialogComponent>) {
    dialogRef.addPanelClass('eForms-dialog-wide');

    dialogRef.disableClose = true;
    dialogRef
      .keydownEvents()
      .pipe(
        filter((e: KeyboardEvent) => e.code === 'Escape'),
        take(1)
      )
      .subscribe(() => dialogRef.close());

    this.dateAsText = this.dateUtilsService.getFormattedDateTimeAsString();
    this.buildNumber = version.buildNumber;
    this.buildVersion = version.version;
  }

  dismissed() {}

  protected readonly FormType = FormType;
}
